module.exports = __webpack_public_path__ + "media/src/public/img/promo-slide-bg-7f7d8c93fb4d1c90e811fd1e0513f189.webp";